import { inboxesSelector } from './inboxes.selector';
import { userDataSelector } from './user.selector';
import { workdeskFilterSelector } from './workdesk-filter.selector';
import { numTicketsStateSelector } from './num-tickets.selector';
import {
  ticketSelector,
  ticketDataSelector,
} from './ticket.selector';
import { unlockFileSelector } from './unlock-file.selector';
import {
  curBookingsSelector,
  curBookingsBookingsSelector,
  viewingIndexSelector,
} from './cur-bookings.selector';
import { getCurFileSelectedSelector } from './cur-bookings-attachments.selector';
import { fileSelectedWithThumbnailSelector } from 'store/selectors/cur-bookings-attachments.selector';
import {
  ticketGroupTableSelectAllSelector,
  tickGroupTableSelector,
  ticketGroupTableSelectedIdSelector,
} from './ticket-group-table.selector';
import {
  websocketSelector,
  isWsConnectedSelector,
} from './websocket.selector';
import { uploadingFilesSelector } from './uploading-files.selector';

console.debug('index ticketSelector', ticketSelector);
export {
  userDataSelector,
  inboxesSelector,
  workdeskFilterSelector,
  numTicketsStateSelector,
  ticketSelector,
  ticketDataSelector,
  unlockFileSelector,
  curBookingsSelector,
  curBookingsBookingsSelector,
  viewingIndexSelector,
  fileSelectedWithThumbnailSelector,
  getCurFileSelectedSelector,
  ticketGroupTableSelectAllSelector,
  tickGroupTableSelector,
  ticketGroupTableSelectedIdSelector,
  websocketSelector,
  isWsConnectedSelector,
  uploadingFilesSelector,
};
